<template>
  <div class="com-box" :style="{height: isEdit ? null : pagesHeight + 'px'}">
    <div class="front" :class="{'active-front': isEdit}" ref="element">
      <div class="head" v-if="!isApplayTemp">
        <div class="head-left">
          <div class="item" v-if="cmpIndex != 0" @click="moveUp">上移</div>
          <div class="item" v-if="comListLength != cmpIndex" @click="shiftDown">下移</div>
          <div class="item" v-if="comListLength > 0" @click="delCmp">删除</div>
        </div>
        <div class="head-right" @click="edit">编辑</div>
      </div>
      <preview-lottery :comData="{...value, lotteryMode:luckDraw.lotteryMode}" :isEdit='isEdit' :tmpType="tmpType"/>
    </div>
    <div class="back" :class="{'active-back': isEdit}" >
      <lottery v-model="formData" :isDit="isEditActivity" :createdTime="createdTime"/>
      <lottery-conf 
        v-model="luckDrawConf" 
        :isHasSignUp="isHasSignUp" 
        :isHasreserve="isHasreserve" 
        :basicInfoForm="basicInfoForm"
        ref="lotteryConfRef"
      />
      <div style="height: 60px;"></div>
      <div class="footer">
        <div class="footer-item call" @click="cancel">取消</div>
        <div class="footer-item" @click="save">保存</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import previewLottery from '@/pages/activity-home/components/lottery'
import lottery from '../../components/lottery'
import lotteryConf from '../../components/lottery-conf'
import dayjs from "@/utils/dayjs";
import _ from 'loadsh'
export default {
  components: {
    previewLottery,
    lottery,
    lotteryConf
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: Object,
    luckDraw: Object,
    basicInfoForm: Object,
    isHasSignUp: Boolean,
    isHasreserve: Boolean,
    cmpIndex: Number,
    comListLength: Number,
    isApplayTemp: Boolean,
    tmpType: Number,
    createdTime: [String, Number]
  },
  computed: {
    ...mapGetters({
      // 经销商
      isDistributor: 'isDistributor',
      // 店长
      isShopowner: 'isShopowner',
      // 导购
      isGuide: 'isGuide',
      // 活动老师
      isTeacher: 'isTeacher',
    }),
    // 是否编辑
    isEditActivity() {
      return this.$route.query.from == 'manager' ? true : false
    },
    // 来源
    source() {
      return this.$route.query.tmpId 
    },
  },
  watch: {
    value: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.formData = _.cloneDeep(this.value)
        }
      },
      deep: true,
      immediate: true
    },
    luckDraw: {
      handler(newVal,oldVal) {
        if (newVal !== oldVal) {
          this.luckDrawConf = _.cloneDeep(this.luckDraw)
        }
      },
      deep: true,
      immediate: true
    },
    basicInfoForm: {
      // 根据活动时间设置抽奖默认时间
      handler(newVal,oldVal) {
        // 只有创建活动设置默认值
        if (Object.keys(newVal).length && this.source) {
          let { startTime, endTime } = newVal;
          if (startTime) {
            startTime = startTime.split(" ").length > 1 ? startTime : startTime + " 00:00:00";
            endTime = endTime.split(" ").length > 1 ? endTime : endTime + " 23:59:59";
            this.luckDraw.lotteryStartDate = startTime;
            this.luckDraw.lotteryEndDate = endTime;
            this.luckDraw.exchangeEndDate = endTime;
            let date = endTime.replace(/-/g, "/");
            this.luckDraw.exchangeEndDate =  dayjs(new Date(date).getTime() + 86400000).format('YYYY-MM-DD HH:mm:ss');
            this.luckDrawConf = _.cloneDeep(this.luckDraw)
            this.$emit('update:luckDraw', this.luckDrawConf)
          }
        }
      }
    }
  },
  data() {
    return {
      isEdit: false,
      formData: {},
      luckDrawConf: {},
      pagesHeight: '778',
    }
  },
  mounted() {
    // 获取组件高度
   this.$nextTick(()=> {
    let height = this.$refs.element.offsetHeight;
    this.pagesHeight = height  == '0' ? '778' : height + 10
   })
  },
  methods: {
    edit() {
      this.formData = _.cloneDeep(this.value)
      this.luckDrawConf = _.cloneDeep(this.luckDraw)
      this.isEdit = true
      this.$emit('handle',['lottery',false])
    },
    cancel() {
      this.isEdit = false
      this.$emit('handle', ['lottery',true])
    },
    save() {
      let isPass =  this.$refs.lotteryConfRef.checkValid()
      if (isPass) {
        this.$emit('change', this.formData)
        this.$emit('update:luckDraw', this.luckDrawConf)
        this.$nextTick(()=> {
          this.pagesHeight = this.$refs.element.offsetHeight + 10
          this.isEdit = false
          this.$emit('handle', ['lottery',true])
        })
      }
    },
    checkValid() {
      return this.$refs.lotteryConfRef.checkValid()
    },
    delCmp() {
      this.$emit('delCmp',this.cmpIndex)
    },
    moveUp() {
      this.$emit('moveUp',this.cmpIndex)
    },
    shiftDown() {
      this.$emit('shiftDown',this.cmpIndex)
    }
  }
}
</script>

<style lang="stylus" scoped>
.com-box {
  position: relative;
  perspective: 800px;
  overflow hidden
  padding: 10px 0;
  box-sizing: border-box;
  .front {
    position: absolute;
    left: 0;
    right: 0;
    transition: 1s;
    z-index: 1;
    backface-visibility: hidden;
    .head {
      position: absolute;
      top: 10px;
      left: 10px;
      width: 95%;
      display: flex;
      justify-content: space-between;
      z-index: 9;
      .head-left {
        display: flex;
        .item {
          padding: 4px;
          border-radius: 3px;
          background: #fff;
          margin-right: 10px;
        }
      }
      .head-right {
        padding: 4px;
        border-radius: 3px;
        background: #fff;
      }
    }
  }
  .back {
    transform: rotateY(-180deg);
    backface-visibility: hidden;
    transition: 1s;
    margin-top: -10px;
    background: #fff;
    .footer {
      display: flex;
      justify-content center;
      width: 100%;
      padding: 10px 0;
    }
    .footer-item {
      color: #FFFFFF;
      padding: 10px 26px;
      border-radius: 4px;
      background: #FF6B31;
      margin-left: 20px;
    }
    .call {
      color: #FF6B31;
      background: #F4F4F4;
    }
  }
  .active-front {
    transform: rotateY(180deg);
  }
  .active-back {
    transform: rotateY(0deg);
  }
}
  
</style>